import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";

class GetFloorPlanIconAction extends BaseAction<{ floorPlanResponseData: any }, void> {
    protected override deduplicate = true;

    override async run(): Promise<{ floorPlanResponseData: any } | null> {
        try {
            // Fetch data from the local JSON file
            const response = await fetch('/assets/json/icons_old.json');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            if (data) {
                updateRecoilState("floorPlanIconsResponseAtom", data);
                return data;
            } else {
                console.warn("Failed to fetch or parse local JSON data.");
                return null;
            }
        } catch (error: any) {
            console.error("Error fetching local JSON Data:", error);
            return null; // Return null on error as per original logic
        }
    }
}

export const getFloorPlanIconAction = new GetFloorPlanIconAction()


